export default function initBlogSearch(state) {
    if (state) {
        setInputToCurrentSearch(state.lastSearch);
    }
}

/**
 * Postavlja posljednju (trenutno) traženu vrijednost polja unosa tražilice.
 *
 * @param {string} keyword
 */
function setInputToCurrentSearch(keyword) {
    if (keyword) {
        document.getElementById('blogSearchForm_keywords').value = keyword;
    }
}
